import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { generateUrls } from '@hooks/usePublication'
import usePublicationCompatiblePagination from '@hooks/usePublicationCompatiblePagination'

const confirmDelete = (deleteCompatiblePagination, deleteFn) => {
  const compatiblePaginationPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Compatible Pagination Deleted',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, delete it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Delete Compatible Pagination?',
  }).then(({ value }) => {
    if (value){
      deleteCompatiblePagination(compatiblePaginationPayload)
    }
  })
}

const CompatiblePagination = (props) => {
  const { publicationCompatiblePagination } = props

  const { callbacks } = useContext(PageContext)
  const { deleteCompatiblePagination } = callbacks || {}

  const {
    callbacks: { deletePublicationCompatiblePagination: deleteFn },
    compatiblePublication,
  } = usePublicationCompatiblePagination(publicationCompatiblePagination)

  const { editPublicationUrl } = generateUrls(compatiblePublication)

  return (
    <DashboardModuleListItem title={compatiblePublication.title}>
      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(deleteCompatiblePagination, deleteFn)}
          type="delete"
        />

        <DashboardModuleListItem.Icon href={`${editPublicationUrl}?redirect=${generateRedirectUrl()}`} type="link" />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

CompatiblePagination.propTypes = {
  publicationCompatiblePagination: PropTypes.object.isRequired,
}

export default CompatiblePagination
